import { useEffect } from 'react';
import { useLoadingBarManager } from './LoadingBarContext';

export function useRegisterLoadingTask(id: string, isLoaded: boolean, options?: { weight?: number }): void {
    const manager = useLoadingBarManager();

    useEffect(() => {
        if (!manager) {
            return;
        }

        if (isLoaded) {
            manager.complete(id);
        } else {
            manager.register(id, options);
        }
    }, [manager, id, isLoaded, options]);
}
